import { IUserInfo } from '../../ts/models/IUserInfo';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import { UserSettingsActions } from './UserSettingsActions';
import { Messages } from '../../codegen/Localize';
import { ActionDialogBodyWithInlineErrorMessageState, ActionDialogBodyWithInlineErrorMessageProps, ActionDialogBodyWithInlineErrorMessage } from '../../commonInfra/dialogs/ActionDialogBodyWithInlineErrorMessage';
import { openReactActionDialog } from '../../commonInfra/dialogs/ReactActionDialog';
import { MergeOrUpdateStateAction } from '@tableau/vizportalclient-common-components';

const initialDialogState: ActionDialogBodyWithInlineErrorMessageState = {
};

export default function showResetStartPageDialog(user: IUserInfo): ng.IPromise<any> {
    const initialBodyProps: ActionDialogBodyWithInlineErrorMessageProps = {dialogMessage: Messages.resetStartPageConfirmMessage()};
    const dialogInstance = openReactActionDialog<ActionDialogBodyWithInlineErrorMessageProps, ActionDialogBodyWithInlineErrorMessageState, IResult>({
        title: Messages.resetStartPageConfirmTitle(),
        actionName: Messages.resetStartPageConfirmButton(),
        actionDisabled: (props: ActionDialogBodyWithInlineErrorMessageProps, state: ActionDialogBodyWithInlineErrorMessageState) => { return false; },
        isActionDelete: false,
        dialogWidth: TabDialogWidth.width375px,
        bodyComponent: ActionDialogBodyWithInlineErrorMessage,
        action: (_, state, updateDialogState) => {
            return restartPageAction(updateDialogState, user);
        },
        dismissDialogOnActionFailed: false,
        initialBodyProps,
        initialDialogState
    });
    return Promise.resolve(dialogInstance.result);
}

async function restartPageAction(
    updateDialogState: React.Dispatch<MergeOrUpdateStateAction<ActionDialogBodyWithInlineErrorMessageState>>,
    user: IUserInfo): Promise<IResult> {
    const result = await UserSettingsActions.resetStartPage(user);
    if (!result || result.errors) {
        updateDialogState({errorMessage: Messages.resetStartPageError()});
      return Promise.reject();
    }
    return Promise.resolve(result);
}